import React from 'react';
import {connect} from 'react-redux';
import {Col, Glyphicon, Button} from 'react-bootstrap'
import Truncate from 'react-truncate';
import classnames from 'classnames';
import ArrowButton from '../common/button-arrow'

const Staff = ({staff, open, row, onEditStaffClicked, onResendClicked}) => {

  let status = staff.attributes.status;

  if (!status) {
    status = '';
  }

  const isEditable = status !== 'disabled';
  const isResendable = status === 'invited' || status === 'expired';

  return (
    <Col md={4}>
      <div className={classnames('panel', 'staff-item', {open: open})}>
        <div className="panel-body">
          <div className="header">
            <div className="staff-name">
              <Truncate lines={2}>
              {staff.attributes['name'].toUpperCase()}
              </Truncate>
            </div>
            <div className="role">{staff.attributes['store-name']}</div>
          </div>

        </div>

        <div className={classnames('panel-footer', status)}>
          <div className={"status text-center"} >{status.toUpperCase()}</div>
          <div className="action-container">
            {isEditable && <div>{status} {staff.attributes['status-updated-at']}</div>}
            {isResendable &&
            <div className="resend-button-container">
              <ArrowButton color={'white'}
                           ghost
                           className="resend-button"
                           arrow={false}
                           submit={false}
                           onClick={() => onResendClicked(staff.links['resend-invitation'], staff.id)}>Resend</ArrowButton>
            </div>
            }
            {isEditable &&
            <div className="edit-staff-button-container">
              <ArrowButton color={'white'}
                           ghost
                           className="edit-staff-details-btn"
                           arrow={false}
                           submit={false}
                           onClick={() => onEditStaffClicked(staff.links.update, row, status, staff.id)}><Glyphicon
                glyph="pencil"/>edit details</ArrowButton>
            </div>
            }
          </div>
          <div className="clearfix"/>
        </div>
      </div>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    staff_member_row: state.staff.staff_member_row,
    staff_member_id: state.staff.staff_member_id
  };
};

export default connect(mapStateToProps)(Staff);



// WEBPACK FOOTER //
// ./src/components/my-staff/staff.jsx